import axios from 'axios';

import { EnumNetworkSetting, EnumSystemSetting } from '@/constant/enums';
import i18n, { getLocale } from '@/locales';
import { message } from '@/utils/message';
import {
    handleConfigureAuth,
    handleDocRequest,
    handleFailRequest,
    handleRefreshToken,
    transformRequestData
} from './tools';

/**
 * 请求前拦截
 */
axios.interceptors.request.use(
    async (config) => {
        let skipToken = config.headers && config.headers['SkipToken'];
        if (config.headers) {
            config.data = await transformRequestData(config, config.data);
        }

        if (!skipToken) {
            config = await handleConfigureAuth(config);
        } else {
            if (config.headers) {
                delete config.headers.SkipToken;
            }
        }
        let currentLocale = getLocale();
        config.headers['Cotton-Accept-Language'] = currentLocale;
        config.headers['Accept-Language'] = currentLocale;

        // 设置超时时间
        config.timeout = EnumNetworkSetting.timeout;
        return config;
    },
    (error) => {
        // 目前并没有能够触发的情况
        // handleNetworkError()
        message.error(i18n.t('common.contactAdmin') || '请联系管理员');
    }
);

/**
 * 响应后拦截
 */
axios.interceptors.response.use(
    async (response) => {
        // console.log("响应");
        // 只有响应码小于200的才会走此请求 这里的响应码对应的逻辑是什么，应该和后端进行协商
        if (response.status !== 200) return Promise.reject(response.data);
        let status = response.status;
        let customCode = null;
        if (response.data.code) {
            customCode = response.data.code;
        }
        let result = response.data;

        // TODO 这里需要规定好，刷新令牌返回码
        if (customCode && customCode === EnumSystemSetting.identityExpiredCode) {
            handleRefreshToken(response.config);
        }
        if (customCode !== 200) {
            message.error(response.data.message);
        }
        // 处理doc文档
        response = await handleDocRequest(response);
        return response;
    },
    async (axiosError) => {
        // 只有响应码超过200的才会走此请求
        let message = '';
        let status = null;
        let responseData = null;
        let response = null;
        if (axiosError.message) {
            message = axiosError.message;
        }
        if (axiosError.response) {
            responseData = axiosError.response.data;
            status = axiosError.response.status;
            response = axiosError.response;

            if (responseData && responseData.code === EnumSystemSetting.identityExpiredCode) {
                handleRefreshToken(response.config);
                return;
            }
        }
        // 这里返回的状态码应该是后端自己定义的，浏览器的响应码在上面已经做了拦截
        return await handleFailRequest(status, message, response);
    }
);

export const Get = (uri, params = {}, clearFn) =>
    new Promise((resolve) => {
        axios
            .get(uri, { params })
            .then((result) => {
                // TODO 因为前端获取的是浏览器的code，这里改变原则
                let data = {
                    code: null,
                    data: null,
                    message: null
                };
                if (result.status) {
                    data.code = result.status;
                }
                if (result.data && result.data.data) {
                    data.data = result.data.data;
                }
                if (result.data && result.data.message) {
                    data.message = result.data.message;
                }
                resolve(result.data);
                // resolve(result.data);
            })
            .catch((err) => {
                resolve(err, undefined);
            });
    });

export const Post = (uri, data, params = {}) => {
    return new Promise((resolve) => {
        axios
            .post(uri, data, params)
            .then((result) => {
                // TODO 因为前端获取的是浏览器的code，这里改变原则
                let data = {
                    code: null,
                    data: null,
                    message: null
                };
                if (result.status) {
                    data.code = result.status;
                }
                if (result.data && result.data.data) {
                    data.data = result.data.data;
                }
                if (result.data && result.data.message) {
                    data.message = result.data.message;
                }
                resolve(result.data);
                // resolve(result.data);
            })
            .catch((err) => {
                resolve(err, undefined);
            });
    });
};
